import { useState } from 'react';
import { EyeOffSvg, EyeOnSvg } from '../../assets/svgs';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import { EyeButton, Input, InputWrapper } from './input.style';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';

const InputComponent = ({ type = 'text', mui, ...props}) => {
    const [showPassword, setShowPassword] = useState(false);

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <InputWrapper>
            {
                mui ? (
                    <>
                        {
                            type === 'date' ? (
                                <DatePicker
                                    label={props?.label || 'Date Picker'}
                                    name={props?.name}
                                    value={props?.value ? dayjs(props.value) : null}
                                    placeholder={props?.placeholder || 'Select date'}
                                    onChange={(newValue) => {
                                        // const formattedValue = newValue ? newValue.format('YYYY-MM-DDTHH:mm') : '';
                                        const formattedValue = newValue ? newValue.format('YYYY-MM-DD') : '';
                                        props?.onChange({ target: { name: props?.name, value: formattedValue } }); // Pass string like "2025-08-28T00:00"
                                    }}
                                    onBlur={props?.onBlur}
                                    minDate={props?.min ? dayjs(props.min) : undefined}
                                    maxDate={props?.max ? dayjs(props.max) : undefined}
                                    disabled={props?.disabled}
                                    slotProps={{
                                        textField: {
                                            variant: 'filled',
                                        },
                                    }}
                                />
                            ) : type?.includes('datetime') ? (
                                <DateTimePicker
                                    label={props?.label || 'Date Time Picker'}
                                    name={props?.name}
                                    value={props?.value ? dayjs(props.value) : null}
                                    placeholder={props?.placeholder || 'Select date and time'}
                                    onChange={(newValue) => {
                                        const formattedValue = newValue ? newValue.format('YYYY-MM-DDTHH:mm') : '';
                                        props?.onChange({ target: { name: props?.name, value: formattedValue } }); // Pass string like "2025-08-28T00:00"
                                    }}
                                    onBlur={props?.onBlur}
                                    minDateTime={props?.min ? dayjs(props.min) : undefined}
                                    maxDateTime={props?.max ? dayjs(props.max) : undefined}
                                    disabled={props?.disabled}
                                    slotProps={{
                                        textField: {
                                            variant: 'filled',
                                        },
                                    }}
                                />
                            ) : (
                                <TextField
                                    type={showPassword ? 'text' : type}
                                    {...props}
                                    variant="filled"
                                    inputProps={{
                                        min: props?.min,
                                        max: props?.max,
                                        ...props?.inputProps,
                                    }}
                                />
                            )
                        }
                        {
                            type === 'password' && (
                                <EyeButton>
                                    {
                                        showPassword ? (
                                            <EyeOffSvg onClick={handleShowPassword} />
                                        ) : (
                                            <EyeOnSvg onClick={handleShowPassword} />
                                        )
                                    }
                                </EyeButton>
                            )
                        }
                    </>
                ) : (
                    <>
                        <Input type={showPassword ? 'text' : type} {...props} className={type === 'password' ? 'password' : ''} />
                        {
                            type === 'password' && (
                                <EyeButton>
                                    {
                                        showPassword ? (
                                            <EyeOffSvg onClick={handleShowPassword} />
                                        ) : (
                                            <EyeOnSvg onClick={handleShowPassword} />
                                        )
                                    }
                                </EyeButton>
                            )
                        }
                    </>
                )
            }
        </InputWrapper>
    );
};

InputComponent.propTypes = {
    type: PropTypes.oneOf([
        'text',
        'email',
        'password',
        'number',
        'tel',
        'time',
        'date',
        'datetime-local',
        'week',
        'month',
        'file',
    ]),
};

export default InputComponent;